function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { createPortal } from 'react-dom';
import useKeyListener from '../../../helpers/hooks/useKeyListener';
var ArticleSlideshow = function ArticleSlideshow(_ref) {
  var _ref$slideshow = _ref.slideshow,
    slideshow = _ref$slideshow === void 0 ? [] : _ref$slideshow;
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    selected = _useState4[0],
    setSelected = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    key = _useState6[0],
    setKey = _useState6[1];
  useKeyListener({
    onKeyUp: function onKeyUp(e) {
      return setKey(e.code);
    }
  });
  useEffect(function () {
    if (key === 'Escape') setVisible(false);else if (key === 'ArrowLeft') prev();else if (key === 'ArrowRight') next();
  }, [key]);
  var prev = function prev() {
    if (slideshow.length < 1) return;
    setSelected(selected === 0 ? slideshow.length - 1 : selected - 1);
  };
  var next = function next() {
    if (slideshow.length < 1) return;
    setSelected(selected === slideshow.length - 1 ? 0 : selected + 1);
  };
  if (slideshow.length === 0) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "a-slideshow"
  }, slideshow.map(function (x, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "a-slideshow__container",
      onClick: function onClick() {
        setSelected(i);
        setVisible(true);
      },
      key: x._id
    }, /*#__PURE__*/React.createElement("img", {
      src: "".concat(bucket, "/").concat(x.filename),
      alt: x.altTag
    }));
  })), visible && /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement("div", {
    className: "image-viewer",
    onClick: function onClick(e) {
      if (e.target.className === 'image-viewer') setVisible(false);
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: "image-viewer__img",
    src: "".concat(bucket, "/").concat(slideshow[selected].filename),
    alt: slideshow[selected].altTag,
    title: slideshow[selected].title
  }), /*#__PURE__*/React.createElement("div", {
    className: "image-viewer__title"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, slideshow[selected].title), /*#__PURE__*/React.createElement("h2", null, slideshow[selected].subtitle))), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/x@3x.png",
    className: "image-viewer__close",
    onClick: function onClick() {
      return setVisible(false);
    }
  }), slideshow.length > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/arrow-left@3x.png",
    className: "image-viewer__prev",
    onClick: function onClick() {
      return prev();
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/arrow-right@3x.png",
    className: "image-viewer__next",
    onClick: function onClick() {
      return next();
    }
  }))), document.getElementById('root')));
};
export default ArticleSlideshow;